import { FC, useMemo } from 'react';
import { SelectProps } from 'antd';
import styled from 'styled-components';

import { DotColorByStatus } from '@/features/vfo/components';
import { Select as SelectAntd } from '@/features/vfo/uikit/Select';

import { useI18nValues } from '../hooks/useI18nValues';
import { UserStatus } from '../types';
import { ActivationStatus } from '../types';

const statusesList = Object.values(UserStatus);

export type FilterUserStatus = UserStatus | 'INVITED';

type SelectVfoStatusProps = SelectProps & {
  withInvited?: boolean;
};

export const SelectVfoStatus: FC<SelectVfoStatusProps> = ({
  placeholder,
  withInvited,
  ...props
}) => {
  const value = useI18nValues();

  const statusOptions = useMemo(() => {
    return statusesList.map((status) => ({
      value: status,
      label: (
        <LabelContainer>
          <DotColorByStatus status={status} isVfoActivated />
          {value.userStatus(status, ActivationStatus.ACTIVE)}
        </LabelContainer>
      ),
    }));
  }, []);

  const options = [
    ...statusOptions,
    ...(withInvited
      ? [
          {
            value: 'INVITED',
            label: (
              <LabelContainer>
                <DotColorByStatus status={UserStatus.OFFLINE} isVfoActivated={false} />
                {value.userStatus(UserStatus.OFFLINE, ActivationStatus.INVITED)}
              </LabelContainer>
            ),
          },
        ]
      : []),
  ];

  return <SelectAntd placeholder={placeholder} options={options} {...props} />;
};

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
